var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLtseLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 58,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0H45V58H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.822 12.903h-5.135v13.57H27.05v-13.57h-5.137V9.08h14.908v3.822zM35.847 35.5h-6.584V38.4h5.215v3.822h-5.215v3.001h6.584v3.822h-11.22V31.628h11.22v3.873zm-14.88 10.183a5.415 5.415 0 0 1-1.344 1.822c-.58.513-1.317.898-2.186 1.18-.87.282-1.844.41-2.924.41-2.265 0-4.346-.641-6.295-1.924l2.002-3.565c.685.59 1.37 1.026 2.055 1.309.684.28 1.343.436 2.001.436.764 0 1.317-.155 1.686-.488.368-.334.553-.693.553-1.129a1.66 1.66 0 0 0-.132-.666 1.713 1.713 0 0 0-.474-.514c-.21-.154-.5-.307-.869-.436-.343-.128-.79-.282-1.29-.461-.606-.18-1.186-.386-1.765-.59-.58-.206-1.08-.514-1.554-.873a3.964 3.964 0 0 1-1.08-1.36c-.29-.538-.421-1.23-.421-2.077 0-.846.157-1.59.447-2.282a4.945 4.945 0 0 1 1.238-1.745 5.365 5.365 0 0 1 1.95-1.129c.763-.282 1.633-.41 2.58-.41.896 0 1.818.128 2.766.359.974.231 1.59.528 2.459.99l-1.148 3.738c-.5-.384-1.39-.932-1.917-1.137a4.406 4.406 0 0 0-1.475-.282c-.606 0-1.08.128-1.475.41-.368.283-.58.616-.58 1.052 0 .308.106.539.29.744.185.205.448.359.738.513.316.154.658.257 1.054.359.395.103.763.205 1.159.334 1.527.487 2.633 1.128 3.318 1.923.711.795 1.053 1.847 1.053 3.13a4.914 4.914 0 0 1-.42 2.36zM13.933 9.055v13.57h9.17l-1.069 3.822H9.298V9.055h4.636zM0 58h45V0H0v58z",
    fill: "#24262C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtseLogo);
export default __webpack_public_path__ + "static/media/ltse-logo.5bd62d3569f58d6c58825f10f6fdae08.svg";
export { ForwardRef as ReactComponent };